import React from 'react';

const normalizeText = (value) => String(value ?? '').trim();

export default function SidebarInstanceStamp({
  kernelVersion,
  productName,
}) {
  const metadata = [productName, kernelVersion ? `内核版本 ${kernelVersion}` : '']
    .map(normalizeText)
    .filter(Boolean);
  if (!metadata.length) {
    return null;
  }
  return (
    <div className="flare-sidebar-instance-stamp">
      {metadata.join(' · ')}
    </div>
  );
}
